import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Container } from "./Container";
import { Config } from "./Config";
import { Provider, staticAction } from "./Provider";
import { withModal } from "./withModal";
import { useModal } from "./useModal";
import { Footer } from "./Footer";
import ContentScroll from "./Components/ContentScroll";
import PopupItem from "./Components/PopupItem";
const Modal = {
    ...forwardRef(({ ...args }, ref) => _jsx(Container, { ...args, ref: ref })),
    Provider,
    Footer,
    ContentScroll,
    PopupItem,
    Config,
    show: (name) => staticAction.current.show(name),
    hide: (name) => staticAction.current.hide(name),
    withModal,
    useModal
};
export { withModal, useModal, Provider as ModalProvider, Config as ModalConfig, Footer as ModalFooter, ContentScroll as ModalContentScroll, PopupItem as ModalPopupItem };
export default Modal;
